import React from 'react';
import { Spinner } from '@fabric-ui/icons';
import { flex } from '@fabric-ui/theme';
import { Box } from '@mui/material';

const animateSpinner = {
  '@keyframes spin': { '0%': { transform: 'rotate(0deg)' }, '100%': { transform: 'rotate(360deg)' } },
};
interface LoadingProps {
  /** deprecated - replace with @property size */
  height?: number;
  size?: number;
  color?: string;
}

export const Loading: React.FC<LoadingProps> = ({ height = 56, size = height, color = '#2160E1' }) => (
  <Box sx={{ ...flex.center, animateSpinner, height, width: height }}>
    <Spinner
      style={{
        animation: 'spin 1.7s linear infinite',
        color,
        height: size,
        width: size,
      }}
    />
  </Box>
);
